import React from 'react'

import { StatusTag } from '@components/common/StatusTag'
import type { TableHeaders } from '@fourthwall/components'

import type { Collection } from '../../types'
import { CollectionTableCell } from '../CollectionTableCell'

export const TABLE_HEADERS: TableHeaders<Collection> = [
  {
    id: 'name',
    label: 'Collection',
    render: ({ name, offerIds, primaryImg }) => (
      <CollectionTableCell
        name={name}
        quantity={offerIds.length}
        photoUrl={primaryImg?.thumbnailUrl}
      />
    ),
    width: 5,
    height: 95,
  },
  {
    id: 'status',
    label: 'Status',
    render: ({ state, timeFrame }) => <StatusTag status={state.status} timeFrame={timeFrame} />,
    width: 2,
  },
]
